import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import AvatarHome from "../../components/AvatarHome";
import Alert from "../../components/affiliates/Alert";
import ButtonSchedule from "../../components/Buttons/Buttons";
import NextClass from "../../components/TableClass/NextClass";
import RequestClass from "../../components/TableClass/RequestClass";
import { SCButtonAddInput } from "../../components/Buttons/styles";
import ModalBeAffiliated from "../../components/affiliates/ModalBeAffiliated";
import { setButtonBeAffiliatedMenu } from "../../store/slices/affiliate.slice";

function HomeTeacher() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isAffiliate, affiliateInfo } = useSelector((state) => state.affiliateReducer);

  return (
    <div className="teacher">
      <AvatarHome />

      <div className="wrapperAlert">
        {isAffiliate?.length !== 0 && isAffiliate[0] && (
          <Alert
            type=""
            titleButton="BE_AFFILIATED"
            title="REFER_YOUR_FRIENDS_AND_EARN"
            onClick={() => dispatch(setButtonBeAffiliatedMenu(true))}
          />
        )}
        {affiliateInfo?.length !== 0 && (
          <Alert type="affiliate" titleButton="BE_AFFILIATED" title="REFER_YOUR_FRIENDS_AND_EARN" onClick="" />
        )}
      </div>

      <RequestClass />
      <ButtonSchedule justSchedule={true} />
      <ModalBeAffiliated />

      <div className="nextHome">
        <NextClass />
      </div>

      <div className="buttonsViewall">
        <Link to={`/calendar/`}>
          <SCButtonAddInput mt="0" ml="auto" mb="0" mr="auto" background="#004fff" color="#fff">
            {t("BTN_VIEW_ALL")}
            <i className="fa fa-angle-right" aria-hidden="true" />
          </SCButtonAddInput>
        </Link>
      </div>
    </div>
  );
}

export default HomeTeacher;
